import get from 'lodash/get'
import { connect } from 'react-redux'

import QuotePrintView from './QuotePrintView'


export default connect(state => ({
  data: get(state, 'quotePrint.data', []),
}))(QuotePrintView)
